export const ORDER_BATCH_STATUS = {
  ALL_CREATED: 0,
  PARTIAL_CREATED: 1,
  NO_CREATED: 2
}

export const INTERVAL_LIMIT_TIME = 600000
export const DEBOUNCE_CLICK = 2000
export const MILISECOND_UNIT = 1000
